import { createSlice } from "@reduxjs/toolkit";
import { getDriverLogsAdmin } from "../../api/DriverLogs";

export const driverLogsSlice = createSlice({
  name: "driverLogs",
  initialState: {
    logs: [],
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 1
  },
  reducers: {
    setDriverLogs: (state, action) => {
      state.logs = action.payload.data;
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.limit = action.payload.limit;
      state.totalPages = action.payload.totalPages;
    },
  },
});

export const { setDriverLogs } = driverLogsSlice.actions;

export const getDriverLogsThunk = (params) => async (dispatch) => {
  try {
    const response = await getDriverLogsAdmin(params);
    if (!response.error && response.status === 200) {
      dispatch(setDriverLogs(response.data));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unknown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const selectDriverLogsState = (state) => state.driverLogs;

export default driverLogsSlice.reducer;
